import React, { useEffect, useState } from 'react';
import axios from 'axios';
import WebshopSuccess from './WebshopSuccess';
import apiEndpoints from '../../config/apiEndpoints';
import { useDispatch, useSelector } from 'react-redux';
import { resetWebshop } from '../../store/slice/Webshop.slice';


const PaymentStatusPage = () => {
  const widgetData = JSON.parse(localStorage.getItem("widget") || "{}");
  const { id, resType, lang, key } = widgetData;
  const dispatch=useDispatch()
  const [statusMessage, setStatusMessage] = useState('Processing your payment...');
  const [status, setStatus] = useState('loading');
  const [attempts, setAttempts] = useState(0);

  const maxAttempts = 6;
  const orderId = parseInt(localStorage.getItem('orderId'));
  const urlParams = new URLSearchParams(window.location.search);
  const isPaymentSuccess = urlParams.get('isPaymentSucessfull');
  useEffect(() => {
    const pollStatus = async () => {
      if (!orderId) return;
     
      if (isPaymentSuccess === 'true') {
        try {
            const res = await axios.get(apiEndpoints?.CHECK_ORDER_STATUS(orderId));
          const orderStatus = res.data.status?.toLowerCase();
          if (orderStatus === 'paid') {
            setStatus('success');
            setStatusMessage('Order placed successfully!');
            dispatch(resetWebshop())
          } else if (['open','pending'].includes(orderStatus)) {
            if (attempts < maxAttempts) {
              setTimeout(() => {
                setAttempts(prev => prev + 1);        
              }, 5000);
            } else {
              cancelOrder();
            }
          } else {
            cancelOrder();
          }
        } catch {
          if (attempts < maxAttempts) {
            setTimeout(() => {
              setAttempts(prev => prev + 1);
            }, 5000);
          } else {
            cancelOrder();
          }
        }
      } else {
        cancelOrder();
      }
    };

    const cancelOrder = async () => {
      setStatusMessage('Payment failed. Cancelling order...');
      try {
        await axios.post(apiEndpoints?.CANCEL_ORDER_READDSTOCK(orderId));
      } finally {
        setStatus('error');
        setTimeout(() => {
          window.location.href = `/widget?widgetsetupid=${id}&key=${key}&resType=${resType}&position=${'vertical'}`;
        }, 3000);
      }
    };
    pollStatus();
  }, [attempts]);

  return (
    <WebshopSuccess status={status}  />
  );
};

export default PaymentStatusPage;
